(function () {
  const desktopQuery = window.matchMedia('(min-width: 1025px)');
  const boundCards = new WeakSet();

  function mp4Source(sources) {
    const mp4s = sources.filter((source) => {
      const type = source.mime_type || '';
      return type.indexOf('mp4') !== -1 || source.format === 'mp4';
    });
    if (!mp4s.length) return null;
    mp4s.sort((a, b) => (a.width || 0) - (b.width || 0));
    const largeEnough = mp4s.find((source) => (source.width || 0) >= 720);
    return (largeEnough || mp4s[mp4s.length - 1]).url;
  }

  function bindCard(card) {
    if (boundCards.has(card)) return;
    const placeholder = card.querySelector('[data-card-video]');
    if (!placeholder) return;
    boundCards.add(card);

    let video = null;

    function poster() {
      return card.querySelector('.product-block__image--active');
    }

    card.addEventListener('mouseenter', () => {
      if (!desktopQuery.matches) return;
      if (!video) {
        let sources = [];
        try {
          sources = JSON.parse(placeholder.getAttribute('data-card-video'));
        } catch (error) {
          return;
        }
        const url = mp4Source(sources);
        if (!url) return;
        video = document.createElement('video');
        video.className = 'collection-card__video';
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'none';
        video.src = url;
        video.hidden = true;
        placeholder.parentNode.insertBefore(video, placeholder);
      }
      video.hidden = false;
      const activeImage = poster();
      if (activeImage) activeImage.style.opacity = '0';
      video.play().catch(() => {});
    });

    card.addEventListener('mouseleave', () => {
      if (!video) return;
      video.pause();
      video.hidden = true;
      const activeImage = poster();
      if (activeImage) activeImage.style.opacity = '';
    });
  }

  function pinWishlist(card) {
    const frame = card.querySelector('.image-cont');
    if (!frame) return;
    const host = card.querySelector('wishlist-button-collection');
    if (host && !frame.contains(host)) frame.appendChild(host);
  }

  function scan() {
    document.querySelectorAll('.product-block--collection').forEach((card) => {
      pinWishlist(card);
      bindCard(card);
    });
  }

  let queued = false;
  function queueScan() {
    if (queued) return;
    queued = true;
    window.setTimeout(() => {
      queued = false;
      scan();
    }, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  new MutationObserver(queueScan).observe(document.documentElement, { childList: true, subtree: true });
})();
